export default "__VITE_ASSET__zz$JtafK__"